import React from "react";

function SvgExcel(props) {
  let blur = "";
  if (props.activeMove) {
    blur = "40";
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      id="Icon"
      width={props.width}
      height={props.height}
      viewBox="0 0 168.997 193.139"
    >
      <g id="excel" transform="translate(0 0)">
        <path
          id="Path_16426"
          data-name="Path 16426"
          d="M31.4,0H133.963l54.363,54.152V181.068a12.072,12.072,0,0,1-12.071,12.071H31.4a12.072,12.072,0,0,1-12.071-12.071v-169A12.072,12.072,0,0,1,31.4,0Z"
          transform="translate(-19.329)"
          fill={"#3db39e"+blur}
        />
        <path
          id="Path_16427"
          data-name="Path 16427"
          d="M257.1,54.393H215.028a12.075,12.075,0,0,1-12.071-12.071V.193Z"
          transform="translate(-88.28 -0.072)"
          fill="#2f8a78"
        />
        <path
          id="Path_16428"
          data-name="Path 16428"
          d="M77.317,125.64V204.1h96.569V125.64Zm72.427,6.035v12.071H137.673V131.675ZM113.53,161.853H101.459V149.788H113.53Zm6.036-12.065h12.071v12.065H119.566ZM113.53,167.9v12.066H101.459V167.9Zm6.036,0h12.071v12.066H119.566Zm18.107,0h12.071v12.066H137.673Zm0-6.042V149.788h12.071v12.065Zm-6.036-30.178v12.071H119.566V131.675Zm-18.107,0v12.071H101.459V131.675Zm-30.178,0H95.423v12.071H83.352Zm0,18.113H95.423v12.065H83.352Zm0,18.107H95.423v12.066H83.352Zm0,30.178V186H95.423v12.078Zm18.107,0V186H113.53v12.078Zm18.107,0V186h12.071v12.078Zm18.107,0V186h12.071v12.078Zm30.178,0H155.78V186h12.071Zm0-18.114H155.78V167.895h12.071Zm0-18.107H155.78V149.788h12.071Zm0-18.106H155.78V131.676h12.071Z"
          transform="translate(-41.103 -47.177)"
          fill="#8bd1c5"
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgExcel);
